/**
 * Reshoppit — main JS entry point.
 *
 * src/js/modules/ files are concatenated before this by Gulp.
 * Block-specific JS lives in blocks/{name}/block.min.js and is loaded
 * conditionally via PHP enqueue_assets only when that block is on the page.
 */
document.addEventListener('DOMContentLoaded', function () {
    initNavigation();
    initCart();
    initWishlist();

    if (document.querySelector('.hero'))               initHero();
    if (document.querySelector('.single-product'))     initProductPage();
    if (document.querySelector('.woocommerce-products-header') ||
        document.querySelector('[data-grid-view]'))    initShop();
});
